export default __webpack_public_path__ + "static/media/lp-new-backfit-exercise-02.08645c6c.jpg";